module.exports = __webpack_public_path__ + "img/compete.bd7b5d39.png";